import { PrimaryEventLocation } from '@apps/card/routes/Dashboard/components/ProductDetailsPage/usePrimaryEventLocation';
import { EventType, StationeryTemplateCategoryEnum } from '@graphql/generated';
import { EventInfoData } from '@shared/utils/eventInfo';

export const LOCATIONS = [
  {
    placeId: 'ChIJc88dJ1AVkFQRmZ_S-xv-_Hs',
    Venue: 'Olympic Sculpture Park',
    Address: '2901 Western Avenue',
    City: 'Seattle',
    CityState: 'Seattle, Washington',
    CityST: 'Seattle, WA',
    timezone: 'America/Los_Angeles',
  },
  {
    placeId: 'ChIJI3iV7jlawokRGIVhEkj651U',
    Venue: '1 Hotel Brooklyn Bridge',
    Address: '60 Furman Street',
    City: 'Brooklyn',
    CityState: 'Brooklyn, New York',
    CityST: 'Brooklyn, NY',
    timezone: 'America/New_York',
  },
  {
    placeId: 'ChIJzRcrN00DdkgRa_C_FpJsB7U',
    Venue: 'Searcys at The Gherkin',
    Address: '30 Saint Mary Axe',
    City: 'London',
    CityState: 'London EC3A 8BF',
    CityST: 'London EC3A 8BF',
    timezone: 'Europe/London',
  },
  {
    placeId: 'ChIJdUyx15R95kcRj85ZX8H8OAU',
    Venue: 'Palace of Versailles',
    Address: "Place d'Armes",
    City: 'Versailles',
    CityState: '78000 Versailles',
    CityST: '78000 Versailles',
    timezone: 'Europe/Paris',
  },
  {
    placeId: 'ChIJ43Oq1S4Uc2sRPGg-ARp_n2M',
    Venue: 'Merewether Surfhouse',
    Address: '5 Henderson Parade',
    City: 'Merewether',
    CityState: 'Merewether NSW 2291',
    CityST: 'Merewether NSW 2291',
    timezone: 'Australia/Sydney',
  },
  {
    placeId: 'ChIJ4Rr2JWiLGGARcyRSHuZ-9G8',
    Venue: 'Shibuya Sky',
    Address: '2-24-12 Shibuya',
    City: 'Shibuya',
    CityState: 'Shibuya-ku, Tokyo',
    CityST: 'Shibuya-ku, Tokyo',
    timezone: 'Asia/Tokyo',
  },
];

// Array of dates for the next 36 months
export const MONTHS = Array.from({ length: 36 }, (_, i) => {
  const date = new Date();
  date.setUTCMonth(date.getUTCMonth() + i);
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
  return date.getTime();
});

// prettier-ignore
export const CATEGORIES = [
  { label: 'Save the Date', key: StationeryTemplateCategoryEnum.saveTheDate },
  { label: 'Invitation',    key: StationeryTemplateCategoryEnum.invitation },
  { label: 'Enclosure',     key: StationeryTemplateCategoryEnum.enclosure },
  { label: 'Thank You',     key: StationeryTemplateCategoryEnum.thankYou },
  { label: 'Holiday',       key: StationeryTemplateCategoryEnum.holiday },
  { label: 'Monogram',      key: StationeryTemplateCategoryEnum.monogram },
  { label: 'Napkin',        key: StationeryTemplateCategoryEnum.napkin },
  { label: 'Menu',          key: StationeryTemplateCategoryEnum.menu },
  { label: 'Sign',          key: StationeryTemplateCategoryEnum.sign },
];

export type EventInfoDataPlus = EventInfoData & {
  ownerMiddleName?: string;
  fianceeMiddleName?: string;
};

export const MOCK_EVENT_INFO: EventInfoDataPlus = {
  eventId: '907d1082-291b-5f44-b9ae-de229bcc6f46',
  eventFirebaseId: 'e00c7f0a1828925fce57f33b3f0f3c858104e87954f8d862e',
  eventType: EventType.wedding,
  eventDisplayName: 'ERROR', // Not used.
  ownerFirstName: 'Taylor',
  ownerMiddleName: 'Alex',
  ownerLastName: 'Jenkins',
  fianceeFirstName: 'Jordan',
  fianceeMiddleName: 'Chandler',
  fianceeLastName: 'Reeves',
  locationInfo: {
    // Not used.
    city: 'New York',
    country: 'United States',
    latitude: 40.7127753,
    longitude: -74.0059728,
    name: 'New York, NY, USA',
    placeId: 'ChIJOwg_06VPwokRYv534QaPC8g',
    state: 'New York',
  },
  finalizedDate: {
    milliseconds: 1790146800000,
    dateString: 'September 23, 2026',
  },
};

export const MOCK_LOCATION: PrimaryEventLocation = {
  Venue: 'The Ritz London',
  Address: '150 Piccadilly',
  City: 'London',
  CityState: 'London W1J 9BR',
  CityST: 'London W1J 9BR',
  utcMilliseconds: 1790179200000,
  timezone: 'Europe/Paris',
};
